import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  UPDATE_APPOINTMENT_NOTE,
  UPDATE_APPOINTMENT_NOTE_ERROR,
  UPDATE_APPOINTMENT_NOTE_SUCCESS,
  UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT,
  UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT_ERROR,
  UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT_SUCCESS,
} from '../type';
import { initialState } from './initialize';

const thankYouReducer = handleActions(
  new Map([
    [
      UPDATE_APPOINTMENT_NOTE,
      state => {
        return update(state, {
          noteData: {
            loading: { $set: true },
            error: { $set: '' },
          },
        });
      },
    ],
    [
      UPDATE_APPOINTMENT_NOTE_ERROR,
      (state, action) => {
        return update(state, {
          noteData: {
            loading: { $set: false },
            error: {
              $set: action.payload,
            },
          },
        });
      },
    ],
    [
      UPDATE_APPOINTMENT_NOTE_SUCCESS,
      (state, action) => {
        return update(state, {
          noteData: {
            loading: { $set: false },
            data: {
              $set: action.payload,
            },
          },
        });
      },
    ],
    [
      UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT,
      (state, action) => {
        return update(state, {
          thankYouData: {
            loading: { $set: true },
            error: {
              $set: '',
            },
          },
        });
      },
    ],
    [
      UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT_ERROR,
      (state, action) => {
        return update(state, {
          thankYouData: {
            loading: { $set: false },
            error: {
              $set: action.payload,
            },
          },
        });
      },
    ],
    [
      UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT_SUCCESS,
      (state, action) => {
        return update(state, {
          thankYouData: {
            loading: { $set: false },
            data: { $set: action.payload },
          },
        });
      },
    ],
  ]),
  initialState,
);

export default thankYouReducer;
